import { CommonHeading } from '~/components/flp/Financing.styles';
import Section from '~/components/flp/Section';
import { appAssetsCdnUrl } from '~/constants/environment';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import {
  Container,
  Content,
  Disclaimer,
  DisclaimerLink,
  SocialValueSection,
  Text
} from './SocialValue.styles';
import SocialValueCta from './SocialValueCta';

export default function SocialValue() {
  return (
    <Section
      as={SocialValueSection}
      eventName={ANALYTICS_EVENTS.MARKETING.SECTION_VIEWED_WHYCARVANA}
    >
      <Container>
        <img
          className="h-auto w-full shrink-0 sm:w-[332px] md:w-[422px] lg:w-[678px] xl:w-[750px]"
          src={`${appAssetsCdnUrl}/images/flp/ready-to-apply.png`}
          alt=""
        />
        <Content>
          <CommonHeading>Ready to apply?</CommonHeading>
          <Text>
            Join over <strong>a million customers</strong> who have purchased
            with Carvana financing.
          </Text>
          <SocialValueCta />
        </Content>
      </Container>
      <Disclaimer>
        *Approval rating applies only to customers who meet{' '}
        <DisclaimerLink
          data-analytics-id="Financing Eligibility Link"
          href="/help/payment-and-financing/can-i-finance-with-carvana-if-i-have-bad-credit"
          data-testid="eligibility-requirements"
        >
          eligibility requirements
        </DisclaimerLink>
        , accurately represent their income, and fully and in good faith
        participate in the underwriting process.
      </Disclaimer>
    </Section>
  );
}
